import Vue from "vue";
import VueCookies from "vue-cookies";
import VStripeElements from "v-stripe-elements/lib";
import LoadScript from "vue-plugin-load-script";

import { ValidationProvider, ValidationObserver } from "vee-validate";

import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import "./plugins/validate";
import { i18n } from "./plugins/i18n";
import store from "./store";

// apostrophe-workflow uses lodash < 4, generate fallback functions
const _ = require("lodash");
_.contains = _.includes;
_.pluck = _.map;

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
Vue.use(VStripeElements);
Vue.use(LoadScript);
Vue.use(VueCookies);

Vue.config.productionTip = false;

new Vue({
  vuetify,
  i18n,
  store,
  render: (h) => h(App),
}).$mount("#app");
